"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.designTokens = void 0;
const breakpoint_1 = require("../helpers/breakpoint");
const grid_1 = require("../helpers/grid");
const tokens_1 = require("@volkswagen-onehub/tokens");
/**
 * This map contains values to be used with sizes and spacings. The 'spacing'
 * key is deprecated. Use 'size' instead. This map allows the same values to be
 * available for both keys.
 */
const sizes = {
    static0: '0',
    static100: '4px',
    static150: '8px',
    static200: '12px',
    static250: '16px',
    static300: '20px',
    static350: '24px',
    static370: '28px',
    static400: '32px',
    static450: '40px',
    static500: '44px',
    static510: '48px',
    static515: '52px',
    static520: '56px',
    static530: '64px',
    static535: '68px',
    static550: '72px',
    static565: '80px',
    static575: '84px',
    static600: '92px',
    static625: '96px',
    static650: '100px',
    static750: '120px',
    static800: '132px',
    static900: '156px',
    static1000: '172px',
    static1100: '184px',
    static1200: '196px',
    grid001: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(1) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(1, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid002: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(2) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(2, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid003: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(3) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(3, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid004: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(4) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(4, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid005: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(5) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(5, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid006: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(6) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(6, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid007: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(7) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(7, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid008: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(8) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(8, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid009: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(9) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(9, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid010: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(10) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(10, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid011: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(11) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(11, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid012: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(12) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(12, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid013: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(13) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(13, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid014: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(14) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(14, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid015: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(15) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(15, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid016: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(16) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(16, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid017: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(17) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(17, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid018: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(18) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(18, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid019: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(19) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(19, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid020: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(20) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(20, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid021: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(21) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(21, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid022: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(22) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(22, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid023: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(23) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(23, breakpoint_1.Breakpoints.b2560),
        },
    ],
    grid024: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: (0, grid_1.getGridColumn)(24) },
        {
            breakpoint: `${breakpoint_1.Breakpoints.b2560}px`,
            value: (0, grid_1.getColumnsWidthForBreakpoint)(24, breakpoint_1.Breakpoints.b2560),
        },
    ],
    dynamic0020: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: '4px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b560}px`, value: '4px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b1600}px`, value: '8px' },
    ],
    dynamic0040: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: '12px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b560}px`, value: '20px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b1600}px`, value: '32px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b2560}px`, value: '48px' },
    ],
    dynamic0050: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: '12px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b560}px`, value: '20px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b1600}px`, value: '24px' },
    ],
    dynamic0100: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: '20px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b560}px`, value: '24px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b1600}px`, value: '28px' },
    ],
    dynamic0120: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: '24px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b560}px`, value: '20px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b1600}px`, value: '20px' },
    ],
    dynamic0130: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: '24px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b560}px`, value: '40px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b1600}px`, value: '52px' },
    ],
    dynamic0140: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: '28px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b560}px`, value: '32px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b1600}px`, value: '48px' },
    ],
    dynamic0150: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: '28px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b560}px`, value: '52px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b1600}px`, value: '64px' },
    ],
    dynamic0200: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: '32px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b560}px`, value: '56px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b1600}px`, value: '72px' },
    ],
    dynamic0250: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: '44px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b560}px`, value: '68px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b1600}px`, value: '84px' },
    ],
    dynamic0270: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: '56px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b560}px`, value: '80px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b1600}px`, value: '100px' },
    ],
    dynamic0300: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: '72px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b560}px`, value: '96px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b1600}px`, value: '120px' },
    ],
    dynamic0350: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: '100px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b560}px`, value: '132px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b1600}px`, value: '196px' },
    ],
    dynamic0450: [
        { breakpoint: `${breakpoint_1.Breakpoints.default}`, value: '156px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b560}px`, value: '172px' },
        { breakpoint: `${breakpoint_1.Breakpoints.b1600}px`, value: '184px' },
    ],
    line100: '1px',
    line200: '2px',
};
/**
 * Set of design tokens to be used in the UI themes
 *
 * Only the tokens defined here can be used for component styling
 */
exports.designTokens = {
    animation: {
        duration: {
            duration300: '300ms',
            duration400: '400ms',
            duration500: '500ms',
            duration600: '600ms',
            duration2000: '2000ms',
        },
        timingFunction: {
            timing100: 'ease',
            timing200: 'linear',
            timing300: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
            timing400: 'ease-in',
        },
    },
    global: tokens_1.globalColors,
    shadows: {
        variant1: '0 4px 5px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.1), 0 1px 2px rgba(0,0,0,0.2)',
        variant2: '0 3px 15px rgba(0,0,0,0.1), 0 2px 4px rgba(0,0,0,0.2)',
        variant3: '0 6px 30px rgba(0,0,0,0.1), 0 4px 8px rgba(0,0,0,0.2)',
        variant4: '0px 8px 32px rgba(0, 0, 0, 0.1), 0px 16px 48px rgba(0, 0, 0, 0.05)',
    },
    size: sizes,
};
